import { computed, makeAutoObservable } from 'mobx';
import { tags } from './languages';

export interface LanguageSelectType {
    value: string;
    key: string;
}

export class LanguageState {
    public getLanguageName = (tag: string): string | undefined => {
        const normalizedTag = tag.trim().toLowerCase();

        if (tags.has(normalizedTag)) {
            return tags.get(normalizedTag);
        }

        const strippedTag = normalizedTag.split('-')[0];

        if (strippedTag !== undefined && tags.has(strippedTag)) {
            return tags.get(strippedTag);
        }

        return normalizedTag;
    };

    public getLanguagesNames = (): Map<string, string> => {
        return tags;
    };

    constructor() {
        makeAutoObservable(this);
    }

    @computed get languages(): Array<LanguageSelectType> {
        const out = [];

        for (const [key, value] of tags.entries()) {
            out.push({ key: key, value: value });
        }

        return out;
    }
}
